// These are the types of errors that can be thrown by the factory (from our error classes)
export const ERROR_TYPES = {
  RAISED_ERROR: "RaisedError",
  WEBSITE_NOT_FOUND_ERROR: "WebsiteNotFoundError",
  INTEGRATION_NOT_FOUND_ERROR: "IntegrationNotFoundError",
  LOCATION_NOT_FOUND_ERROR: "LocationNotFoundError",
  INTEGRATION_INSTALLATION_NOT_FOUND_ERROR: "IntegrationInstallationNotFoundError",
  NOT_FOUND_ERROR: "NotFoundError",
  UNAUTHORIZED_ERROR: "UnauthorizedError",
  NO_ORG_ID_ERROR: "NoOrgIdError",
  CONFLICT_ERROR: "ConflictError",
  FORBIDDEN_ERROR: "ForbiddenError",
  OAUTH_ERROR: "OAuthError",
  AUTHORIZATION_CODE_ALREADY_USED_ERROR: "AuthorizationCodeAlreadyUsedError",
  AUTHORIZATION_CODE_EXPIRED_ERROR: "AuthorizationCodeExpiredError",
  AUTHORIZATION_CODE_MISSING_ERROR: "AuthorizationCodeMissingError",
  BAD_REQUEST_ERROR: "BadRequestError",
  NO_FACEBOOK_PAGES_FOUND_ERROR: "NoFacebookPagesFoundError",
  INTERNAL_ERROR: "InternalError",
  EXPECTED_ERROR: "ExpectedError",
  EXTERNAL_ERROR: "ExternalError",
  NOTIFICATION_ERROR: "NotificationError",
  PRISMA_ERROR: "PrismaError",
  CLERK_ERROR: "ClerkError",
  MISMATCHED_ORG_ID_ERROR: "MismatchedOrgIdError",
  GBP_SUSPENDED: "GBPSuspended",
} as const;

export type ErrorType = (typeof ERROR_TYPES)[keyof typeof ERROR_TYPES];
